import { displayToast, sendAppsignalError } from "../modules/utils";

export default class ShowMore {
  constructor(node) {
    this.element = node;
    this.contentWrapper = this.element.querySelector(".js-show-more-wrapper");
    this.showMoreButtonWrapper = this.element.querySelector(".js-show-more-button-wrapper");

    this.initialize();
  }

  initialize() {
    this.addEventListenerToWrapper();
  }

  addEventListenerToWrapper() {
    this.showMoreButtonWrapper.addEventListener("click", (e) => {
      if (e.target.tagName !== "A") return;

      e.preventDefault();
      this.showMore(new URL(e.target.href, window.location.origin));
    });
  }

  showMore(url) {
    this.element.classList.add("is-loading");

    fetch(url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { elements, showMoreButton } = data;

        this.contentWrapper.insertAdjacentHTML("beforeend", elements);
        this.showMoreButtonWrapper.innerHTML = showMoreButton;
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "ShowMore", {
          response: this.response,
        });
      })
      .finally(() => {
        this.element.classList.remove("is-loading");
      });
  }
}
